import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchChargeType } from '@/features/charge-types/api'

import { ChargeTypeParamsSchema } from '../-models/charge-type-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/charge-types/$chargeTypeId'
)({
  parseParams: (params) => parse(ChargeTypeParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, chargeTypeId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      chargeType: await fetchChargeType(
        {
          tenantKey,
          chargeTypeId: chargeTypeId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.chargeType.data.name
    }
  ]
})
